var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('order-body',{attrs:{"isOk":false,"codeStatus":100,"pageText":'orderWait'}})}
var staticRenderFns = []

export { render, staticRenderFns }